import React, { Component } from "react";
import PropTypes from "prop-types";
import Popover from "react/views/generic/Popover";
import Button from "react/views/generic/Button";
import OtsAvailabilityContent from "./OtsAvailabilityContent";
import * as OtsViewFunctions from "./OtsViewFunctions";
import {logFeatureUsage} from "lib/analytics/AnalyticsController";

import "./ots.less";

const otsWidth = 134;

class OtsView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			anchorEl: null,
			open: false
		};

		this.handleMouseDown = this.handleMouseDown.bind(this);
		this.handleClickAway = this.handleClickAway.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.uniqueId !== nextProps.uniqueId) {
			this.closePopover();
		}
	}

	handleMouseDown(event, otsLogging) {
		const { currentTarget } = event;
		const { featureType, srcId, destId } = otsLogging;

		logFeatureUsage(featureType, srcId, destId);
		
		this.setState(prevState => {
			return {
				anchorEl: currentTarget,
				open: !prevState.open
			};
		});
	}

	handleClickAway() {
		this.closePopover();
	}

	closePopover() {
		this.setState({
			open: false
		});
	}

	render() {
		const { loading, data, uniqueId, catalogLink, otsFindItEvent, otsClickLogging } = this.props;
		let button = OtsViewFunctions.getButtonState(loading, data);
		
		return (
			<div>
				{button && (
						<Button small onMouseDown={(event) => this.handleMouseDown(event, otsClickLogging)} disabled={button.disabled} style={{ width: otsWidth }}>
							{button.text}
						</Button>
				)}
				<Popover placement="bottom" open={this.state.open} anchorEl={this.state.anchorEl} handleClickAway={this.handleClickAway}>
					<OtsAvailabilityContent otsData={data} uniqueId={uniqueId} catalogLink={catalogLink} featureType={otsFindItEvent} />
				</Popover>
			</div>
		);
	}
}

OtsView.propTypes = {
	data: PropTypes.array,
	loading: PropTypes.bool,
	error: PropTypes.bool,
	uniqueId: PropTypes.string,
	catalogLink: PropTypes.object,
	otsClickLogging: PropTypes.object
};

export default OtsView;



// WEBPACK FOOTER //
// ./src/react/views/ots/OtsView.jsx